function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AvatarCheckAutocomplete, Tabs, TabsList, TabsTrigger } from '@ui/primitives';
import { DatePicker } from '../datepicker';
export function AuditLogFilters(param) {
    let { type, handleTypeChange, authors, authorIds, handleAuthorChange, dateFrom, dateTo, handleDateFromChange, handleDateToChange, tabsTriggers } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-between",
        children: [
            /*#__PURE__*/ _jsx(Tabs, {
                value: type,
                onValueChange: handleTypeChange,
                children: /*#__PURE__*/ _jsx(TabsList, {
                    children: tabsTriggers.map((trigger)=>/*#__PURE__*/ _jsx(TabsTrigger, {
                            value: trigger.value,
                            children: trigger.label
                        }, trigger.value))
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "ml-4 flex flex-wrap gap-3",
                children: [
                    authors.length > 0 && /*#__PURE__*/ _jsx(AvatarCheckAutocomplete, {
                        options: authors.map((author)=>_object_spread({
                                id: author.id,
                                name: author.name
                            }, author.portrait != null && {
                                avatar: author.portrait
                            }, author.avatarColor != null && {
                                avatarColor: author.avatarColor
                            })),
                        value: authorIds,
                        onChange: handleAuthorChange,
                        placeholder: "All authors"
                    }),
                    /*#__PURE__*/ _jsx(DatePicker, {
                        dateRange: {
                            from: dateFrom,
                            to: dateTo
                        },
                        onDateRangeChange: (value)=>{
                            var _ref, _ref1;
                            handleDateFromChange((_ref = value === null || value === void 0 ? void 0 : value.from) !== null && _ref !== void 0 ? _ref : undefined);
                            handleDateToChange((_ref1 = value === null || value === void 0 ? void 0 : value.to) !== null && _ref1 !== void 0 ? _ref1 : undefined);
                        }
                    })
                ]
            })
        ]
    });
}
